import React, { memo } from "react";
import { styled } from "@mui/system";
import cx from "classnames";
import PropTypes from "prop-types";

import { ContainedButton } from "./ContainedButton";

//using this button in KFS Dialog
export const Button = styled(ContainedButton)(({ theme }) => ({
  fontWeight: 500,
  letterSpacing: "normal",
  minWidth: "130px",
  borderRadius: "100px",
  boxShadow: "none",
  [theme.breakpoints.only("md")]: {
    fontSize: "1.125rem",
    height: "unset",
    minHeight: "auto",
    padding: "12px 30px",
    lineHeight: "20px",
    "> .labelStyle": {
      fontSize: "1.125rem"
    }
  },
  "& svg": {
    width: "24px",
    height: "24px"
  },
  "&:disabled": {
    color: theme.palette.common.white
  }
}));

export const SubmitButtonBase = ({
  submitButtonClassName,
  type = "submit",
  isSearchApplicant = false,
  ...rest
}) => (
  <div className={cx("footerCTA", submitButtonClassName)}>
    <Button type={type} isSearchApplicant={isSearchApplicant} withRightArrow {...rest} />
  </div>
);
SubmitButtonBase.propTypes = {
  submitButtonClassName: PropTypes.string,
  type: PropTypes.string,
  isSearchApplicant: PropTypes.bool
};

export const SubmitButton = memo(SubmitButtonBase);
